module.exports = __webpack_public_path__ + "assets/img/title-10428938.png";